import { isValidNumber } from "./isValidNumber";

// function supportsUnit(unit: string): boolean {
//   try {
//     new Intl.NumberFormat("en-US", {
//       style: "unit",
//       unit,
//     }).format(1);
//     return true;
//   } catch {
//     return false;
//   }
// }

// const hasKnotUnit = supportsUnit("knot");

const numberFormatter = new Intl.NumberFormat("en-GB", {
  maximumFractionDigits: 0,
});

export const getSpeedInKnots = (value?: unknown, fallback = "N/A") => {
  if (!isValidNumber(value)) return fallback;

  const v = Math.floor(value);

  // if (hasKnotUnit) {
  //   const formatter = new Intl.NumberFormat("en-GB", {
  //     style: "unit",
  //     unit: "knot",
  //     unitDisplay: "short",
  //     maximumFractionDigits: 0,
  //   });

  //   return formatter.format(value);
  // }

  // 🔁 Fallback (manual)
  return `${numberFormatter.format(v)} kn`;
};
